import { TableColumn, parseDefaultTableColumns } from '../../../../../context/shared/tableColumns';
import { Task } from '../../../../../domain/task/Task';

export const tasksTableColumnKeys = [
  `driver_id`,
  `stop_id`,
  `stop_order`,
  `label`,
  `comments`,
  `barcode`,
  `status`,
  `created_at`,
] as const;

export type TasksTableColumnKeys = (typeof tasksTableColumnKeys)[number];

export type TasksTableColumn = TableColumn<TasksTableColumnKeys, Task>;

export const TASKS_DEFAULT_TABLE_COLUMNS: Array<TasksTableColumn> = [
  // icon: false,
  {
    identifier: `label`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `driver_id`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `stop_id`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `stop_order`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `barcode`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `comments`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `status`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `created_at`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
];

export const getTasksTableColumns = (): Array<TasksTableColumn> => {
  const storedTableColumns = localStorage.getItem(`TASK_TABLE_COLUMNS`);
  if (!storedTableColumns) return TASKS_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<TasksTableColumn> = [...(Array.isArray(parsedTableColumns) ? parsedTableColumns : [])];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: TASKS_DEFAULT_TABLE_COLUMNS,
  });
};

export const setTasksTableColumns = (tableColumns: Array<TasksTableColumn>) => {
  localStorage.setItem(`TASK_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
